import {TopicEntity} from "../contract/topic";

export type TopicAction = SetTopicAction | SetTopicsAction;

interface SetTopicAction {
  type: 'topic/set';
  payload: any;
}

interface SetTopicsAction {
  type: 'topic/setMultiple';
  payload: any[];
}

// -------
// topic/setMultiple
// -------
export function setTopics(topics: TopicEntity[]): SetTopicsAction {
  return {
    type: 'topic/setMultiple',
    payload: topics,
  };
}

// -------
// topic/set
// -------
export function setTopic(topic: TopicEntity): SetTopicAction {
  return {
    type: 'topic/set',
    payload: topic,
  };
}
